import { defineVariants } from "@/runtime/style-engine/define-variants";

/**
 * Root tab wrapper.
 * Full width, column layout so the list and content panels stack vertically.
 */
export const tabClasses = defineVariants({
  base: "flex flex-col w-full gap-4",
  variants: {},
});

/**
 * Tab list — left-aligned flex row.
 * Items naturally align to the start; gap and padding are defaults consumers can override.
 */
export const tabListClasses = defineVariants({
  base: "flex flex-row gap-1 w-full",
  variants: {},
});

/**
 * Tab content — purely a visibility wrapper.
 * No base styles; consumers style content panels directly.
 */
export const tabContentClasses = defineVariants({
  base: "",
  variants: {},
});

/**
 * Layout for the inner content of a TabTrigger when title + description are rendered.
 */
export const tabTriggerContentClasses = defineVariants({
  base: "flex flex-col gap-0.5 min-w-0 text-left",
  variants: {},
});

/**
 * Description text styling inside a TabTrigger.
 */
export const tabTriggerDescriptionClasses = defineVariants({
  base: "text-xs leading-snug text-(--color-foreground)/50",
  variants: {},
});

/**
 * Override classes applied to the inner `<e-button>` of a TabTrigger.
 *
 * When `hasDescription` is true the trigger renders a stacked title + description.
 * The button's fixed `h-X!` size is too tight for that layout, so per-size
 * `part-[base]:py-X!` and `part-[base]:h-auto!` overrides grow the trigger
 * vertically to fit the content. Also pads `part(leading)` so the icon doesn't
 * hug the top edge.
 */
export const tabTriggerButtonClasses = defineVariants({
  base: "",
  variants: {
    hasDescription: {
      true: `
        part-[base]:items-start!
        part-[base]:h-auto!
        part-[leading]:py-1
      `,
      false: "",
    },
    size: {
      xs: "",
      sm: "",
      md: "",
      lg: "",
      xl: "",
    },
  },
  compoundVariants: [
    { hasDescription: true, size: "xs", class: "part-[base]:py-1!" },
    { hasDescription: true, size: "sm", class: "part-[base]:py-1.5!" },
    { hasDescription: true, size: "md", class: "part-[base]:py-2!" },
    { hasDescription: true, size: "lg", class: "part-[base]:py-2.5!" },
    { hasDescription: true, size: "xl", class: "part-[base]:py-3!" },
  ],
  defaults: {
    hasDescription: false,
    size: "md",
  },
});
